import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { SectionContentLinkListIdFive } from 'components/section-content-link-list';
import { TitleAnchor } from 'components/title-anchor';
import { FormattedText, P1 } from 'components/typography';

const setTitleElement = (id: SectionContentLinkListIdFive) => {
  const mapTitleAnchorToSectionId: {
    [key in SectionContentLinkListIdFive]: {
      id: SectionContentLinkListIdFive;
      title: string;
    };
  } = {
    [SectionContentLinkListIdFive.RightToBeInformed]: {
      id: SectionContentLinkListIdFive.RightToBeInformed,
      title: sections.tabFiveSection.subsection1.item1.title(),
    },

    [SectionContentLinkListIdFive.RightToAccess]: {
      id: SectionContentLinkListIdFive.RightToAccess,
      title: sections.tabFiveSection.subsection1.item2.title(),
    },

    [SectionContentLinkListIdFive.RightToRectify]: {
      id: SectionContentLinkListIdFive.RightToRectify,
      title: sections.tabFiveSection.subsection1.item3.title(),
    },
    [SectionContentLinkListIdFive.RightToDataPortability]: {
      id: SectionContentLinkListIdFive.RightToDataPortability,
      title: sections.tabFiveSection.subsection1.item4.title(),
    },
    [SectionContentLinkListIdFive.RightToErase]: {
      id: SectionContentLinkListIdFive.RightToErase,
      title: sections.tabFiveSection.subsection1.item5.title(),
    },
    [SectionContentLinkListIdFive.RightToRestrictOrObject]: {
      id: SectionContentLinkListIdFive.RightToRestrictOrObject,
      title: sections.tabFiveSection.subsection1.item6.title(),
    },
    [SectionContentLinkListIdFive.RightToComplain]: {
      id: SectionContentLinkListIdFive.RightToComplain,
      title: sections.tabFiveSection.subsection1.item7.title(),
    },
    [SectionContentLinkListIdFive.RightsRelatedToAutomatedDecisionMaking]: {
      id: SectionContentLinkListIdFive.RightsRelatedToAutomatedDecisionMaking,
      title: sections.tabFiveSection.subsection1.item8.title(),
    },
    [SectionContentLinkListIdFive.HowDoYouEnforceYourRights]: {
      id: SectionContentLinkListIdFive.RightsRelatedToAutomatedDecisionMaking,
      title: sections.tabFiveSection.subsection1.item8.title(),
    },
    [SectionContentLinkListIdFive.DoYouLiveInCalifornia]: {
      id: SectionContentLinkListIdFive.RightsRelatedToAutomatedDecisionMaking,
      title: sections.tabFiveSection.subsection1.item8.title(),
    },
  };
  return (
    <TitleAnchor
      titleAnchorElement={TitleAnchor.ElementType.NONE}
      {...mapTitleAnchorToSectionId[id]}
    />
  );
};

export const getPropsSectionFiveContainer = () => {
  /**
   * @todo: add real text
   */
  return {
    sections: {
      one: {
        intro: sections.tabFiveSection.subsection1.intro(),
        cards: [
          // TODO: add card image sources
          {
            title: setTitleElement(SectionContentLinkListIdFive.RightToBeInformed),
            content: sections.tabFiveSection.subsection1.item1.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-01.jpg`,
          },
          {
            title: setTitleElement(SectionContentLinkListIdFive.RightToAccess),
            content: sections.tabFiveSection.subsection1.item2.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-02.jpg`,
          },
          {
            title: setTitleElement(SectionContentLinkListIdFive.RightToRectify),
            content: sections.tabFiveSection.subsection1.item3.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-03.jpg`,
          },
          {
            title: setTitleElement(SectionContentLinkListIdFive.RightToDataPortability),
            content: sections.tabFiveSection.subsection1.item4.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-04.jpg`,
          },
          {
            title: setTitleElement(SectionContentLinkListIdFive.RightToErase),
            content: sections.tabFiveSection.subsection1.item5.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-05.jpg`,
          },
          {
            title: setTitleElement(SectionContentLinkListIdFive.RightToRestrictOrObject),
            content: sections.tabFiveSection.subsection1.item6.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-06.jpg`,
          },
          {
            title: setTitleElement(SectionContentLinkListIdFive.RightToComplain),
            content: sections.tabFiveSection.subsection1.item7.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-07.jpg`,
          },
          {
            title: setTitleElement(
              SectionContentLinkListIdFive.RightsRelatedToAutomatedDecisionMaking,
            ),
            content: sections.tabFiveSection.subsection1.item8.content(),
            imageSrc: `${CdnImagePath}/assets/tab-05/list/tab-05-list-08.jpg`,
          },
        ],
      },
      two: {
        goodToKnow: {
          title: sections.tabFiveSection.subsection2.goodToKnow.title(),
          content: sections.tabFiveSection.subsection2.goodToKnow.content(),
        },
        chat: [
          sections.tabFiveSection.subsection2.chat1(),
          sections.tabFiveSection.subsection2.chat2(),
          sections.tabFiveSection.subsection2.chat3(),
        ],
        text: (
          <FormattedText>
            <P1 html={sections.tabFiveSection.subsection2.text()} as="p" />
          </FormattedText>
        ),
      },
      three: {
        title: sections.tabFiveSection.subsection3.title(),
        subtitle: (
          <FormattedText>
            <P1 html={sections.tabFiveSection.subsection3.subtitle()} as="p" />
          </FormattedText>
        ),
        accordion: sections.tabFiveSection.subsection3.accordion(),
      },
    },
  };
};
